import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  carrierPickUpModalHeader: {
    description: 'carrierPickupModal.modalHeader',
    defaultMessage: 'Schedule {labelProviderName} Pickup for "{sellerLabelProviderName}"',
    id: 'CIrB/P',
  },
  carrierPickUpModalMidnightWarning: {
    description: 'carrierPickupModal.midnightWarning',
    defaultMessage: 'Submit before midnight for next business day pickup.',
    id: 'dSfVIM',
  },
  carrierPickUpModalCancel: {
    description: 'carrierPickupModal.cancel',
    defaultMessage: 'Cancel',
    id: 'of0uLK',
  },
  carrierPickUpModalSchedulePickup: {
    description: 'carrierPickupModal.schedulePickup',
    defaultMessage: 'Schedule Pickup',
    id: 'Xoilhy',
  },
});
